import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/*
 * Combine class names and merge tailwind classes
 * @param {ClassValue[]} inputs - The class names to combine
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/*
 * Convert pixels to rems (returns string with "rem" suffix)
 * @param {number} px - The number of pixels to convert
 */
export function pxToRem(px: number, base = 16) {
  return `${px / base}rem`;
}

/*
 * Convert pixels to rems (returns number)
 * @param {number} px - The number of pixels to convert
 */
export function pxToRemValue(px: number, base = 16) {
  return px / base;
}

export function isEditableElementTarget(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) return false;

  return target.isContentEditable || target.closest("input, textarea, select, [contenteditable]") !== null;
}

export const isNil = (val: any) => val === undefined || val === null;
